module.exports = __webpack_public_path__ + "static/img/2019-10-12 14.17.32.f47cb3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2019-10-12 14.17.32.jpg
// module id = lvrj
// module chunks = 4